module.exports = __webpack_public_path__ + "static/img/coin_d.88bba4f9.png";